import PropTypes from "prop-types";

import { t } from "../../services";
import { strCode } from "../../consts";

import { Paragraph2 } from "../../components";
import { WarningText, StatusIndicatorBackground, StatusIndicatorWrapper } from "./styled";

const StatusIndicator = ({ status, expiresSoon }) => {
  return (
    <StatusIndicatorBackground>
      <StatusIndicatorWrapper status={status?.id}>
        <span />
        <Paragraph2>{t(status?.title)}</Paragraph2>
      </StatusIndicatorWrapper>

      {expiresSoon && <WarningText>{t(strCode.EXPIRES_SOON_INFO)}</WarningText>}
    </StatusIndicatorBackground>
  );
};

StatusIndicator.propTypes = {
  status: PropTypes.shape({ id: PropTypes.string.isRequired, title: PropTypes.string.isRequired })
    .isRequired,
  expiresSoon: PropTypes.bool
};

export default StatusIndicator;
